class Archive {
    constructor() {
        this.main = document.querySelector('.js-cpt-archive');

        if (!this.main) return;

        this.getSelectors();
        this.initDateInputs();
        this.setEventListeners();

        this.data = {
            cpt: this.main.dataset.cpt,
            from: '',
            until: '',
            category: '',
            count: 0
        }

        this.isActive = false;
    }

    getSelectors = () => {
        this.dateInputsSelectors = this.main.querySelectorAll('.js-date-input');
        this.categoryBtns = this.main.querySelectorAll('.js-cpt-category');

        this.errorWrappers = this.main.querySelectorAll('.js-no-posts');
        this.postsGrids = this.main.querySelectorAll('.js-posts-grid');
        this.loadMoreBtns = this.main.querySelectorAll('.js-load-more');

        this.loader = this.main.querySelector('.js-posts-loader');
    }

    initDateInputs = () => {
        if (this.dateInputsSelectors.length > 0) {

            const enLocale = {
                days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                months: ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'],
                monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                today: 'Today',
                clear: 'Clear',
                dateFormat: 'yyyy-MM-dd',
                timeFormat: 'hh:mm aa',
                firstDay: 1
            };

            this.dateInputsSelectors.forEach(input => {

                new AirDatepicker(input, {
                    locale: enLocale, // Set the locale to English
                    classes: 'custom-calendar',
                    firstDay: 1,
                    dateFormat: 'yyyy-MM-dd',
                    position: 'bottom right',
                    autoClose: true,
                    onSelect: ({date, formattedDate}) => {

                        if (input.dataset.input === 'from') {
                            this.data.from = formattedDate;
                        } else {
                            this.data.until = formattedDate;
                        }

                        this.ajaxCall();
                    }
                })
            })
        }
    }

    setEventListeners = () => {
        if (this.categoryBtns.length > 1) {
            this.categoryBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.categoryBtns.forEach(activeBtn => activeBtn.classList.remove('active'));

                    if (btn.value === this.data.category) {
                        this.data.category = '';
                        btn.checked = false
                    } else {
                        btn.classList.add('active');

                        this.data.category = btn.value;
                    }

                    this.ajaxCall();
                })
            })
        }

        if (this.loadMoreBtns.length > 0) {
            this.loadMoreBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    let data = btn.dataset.btn ? btn.dataset.btn : true;

                    this.ajaxCall(data);
                })
            })
        }
    }

    ajaxCall = (loadMore = false) => {

        if (this.isActive) return;

        this.isActive = true;

        if (this.data.cpt === 'events') {
            if (loadMore) {
                if (loadMore === 'upcoming') {
                    this.postsGrids.forEach(grid => {
                        if (grid.dataset.grid === 'upcoming') {
                            this.data.count = grid.querySelectorAll('.js-event-card').length;
                        }
                    })
                } else if (loadMore === 'past') {
                    this.postsGrids.forEach(grid => {
                        if (grid.dataset.grid === 'past') {
                            this.data.count = grid.querySelectorAll('.js-event-card').length;
                        }
                    })
                }
            }
        } else {
            this.data.count = this.main.querySelectorAll('.js-news-card').length;
        }

        this.loader.classList.add('active');

        fetch("/wp-admin/admin-ajax.php", {
            method: "POST",
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams({
                action: 'postsFilter',
                data: JSON.stringify(this.data),
                loadMore: JSON.stringify(loadMore),
            })
        })
            .then((response) => response.json())
            .then((response) => {
                this.handleResponse(response, loadMore, this.data);
            })
            .catch((error) => {
                this.handleResponse(error, loadMore, this.data);
            })
    }


    handleResponse = (response, loadMore = false, data) => {
        if (!response) return false;

        this.isActive = false;

        if (this.data.cpt === 'events') {
            if (!loadMore) {
                if (response.data.upcoming.data.html) {
                    this.replacePosts(response.data.upcoming.data.html, 'upcoming')

                    if (this.errorWrappers.length > 0) {
                        this.errorWrappers.forEach(error => {
                            if (error.dataset.noPosts === 'upcoming') {
                                error.classList.add('hide');
                            }
                        })
                    }
                } else {
                    if (this.postsGrids.length > 0) {
                        this.postsGrids.forEach(grid => {
                            if (grid.dataset.grid === 'upcoming') {
                                grid.innerHTML = '';
                            }
                        })
                    }

                    if (this.errorWrappers.length > 0) {
                        this.errorWrappers.forEach(error => {
                            if (error.dataset.noPosts === 'upcoming') {
                                error.classList.remove('hide');
                            }
                        })
                    }
                }

                if (response.data.past.data.html) {
                    this.replacePosts(response.data.past.data.html, 'past')

                    if (this.errorWrappers.length > 0) {
                        this.errorWrappers.forEach(error => {
                            if (error.dataset.noPosts === 'past') {
                                error.classList.add('hide');
                            }
                        })
                    }
                } else {
                    if (this.postsGrids.length > 0) {
                        this.postsGrids.forEach(grid => {
                            if (grid.dataset.grid === 'past') {
                                grid.innerHTML = '';
                            }
                        })
                    }

                    if (this.errorWrappers.length > 0) {
                        this.errorWrappers.forEach(error => {
                            if (error.dataset.noPosts === 'past') {
                                error.classList.remove('hide');
                            }
                        })
                    }
                }
            } else {
                if (loadMore === 'upcoming') {
                    this.addPosts(response.data.upcoming.data.html, 'upcoming')
                } else {
                    this.addPosts(response.data.past.data.html, 'past')
                }
            }

            this.handleFilterElements(response.data.upcoming.data.count, 'upcoming');
            this.handleFilterElements(response.data.past.data.count, 'past');

        } else {
            if (response.success) {
                if (!response.data.html) {

                    if (this.postsGrids.length > 0) {
                        this.postsGrids.forEach(grid => {
                            grid.innerHTML = '';
                        })
                    }

                    if (this.errorWrappers.length > 0) {
                        this.errorWrappers.forEach(error => {
                            error.classList.remove('hide');
                        })
                    }

                } else {
                    loadMore ? this.addPosts(response.data.html) : this.replacePosts(response.data.html);

                    if (this.errorWrappers.length > 0) {
                        this.errorWrappers.forEach(error => {
                            error.classList.add('hide');
                        })
                    }
                }
            } else {
                if (this.postsGrids.length > 0) {
                    this.postsGrids.forEach(grid => {
                        grid.innerHTML = '';
                    })
                }

                if (this.errorWrappers.length > 0) {
                    this.errorWrappers.forEach(error => {
                        error.classList.remove('hide');
                    })
                }
            }

            this.handleFilterElements(response.data.count);
        }

        this.loader.classList.remove('active');
    }

    replacePosts = (HTMLResults, type = '') => {

        if (this.data.cpt === 'events') {
            this.postsGrids.forEach(grid => {
                if (grid.dataset.grid === type) {
                    grid.innerHTML = HTMLResults ? HTMLResults : ''; // load more
                }
            })
        } else {
            if (this.postsGrids.length > 0) {
                this.postsGrids.forEach(grid => {
                    grid.innerHTML = HTMLResults ? HTMLResults : ''; // filtered
                })
            }
        }
    }

    addPosts = (HTMLResults, type = '') => {

        if (this.data.cpt === 'events') {
            this.postsGrids.forEach(grid => {
                if (grid.dataset.grid === type) {
                    grid.innerHTML += HTMLResults ? HTMLResults : ''; // load more
                }
            })

        } else {
            if (this.postsGrids.length > 0) {
                this.postsGrids.forEach(grid => {
                    console.log(grid, HTMLResults)
                    grid.innerHTML += HTMLResults ? HTMLResults : ''; // load more
                })
            }
        }
    }

    handleFilterElements = (allPostCount, type = '') => {

        if (this.data.cpt === 'events') {
            if (this.postsGrids.length > 0) {
                this.postsGrids.forEach(grid => {
                    if (grid.dataset.grid === type) {
                        const postsCount = grid.querySelectorAll('.js-event-card').length;

                        if (postsCount >= allPostCount) {
                            if (this.loadMoreBtns.length > 0) {
                                this.loadMoreBtns.forEach(btn => {
                                    if (btn.dataset.btn === type) {
                                        btn.classList.add('hide');
                                    }
                                })
                            }
                        } else {
                            if (this.loadMoreBtns.length > 0) {
                                this.loadMoreBtns.forEach(btn => {
                                    if (btn.dataset.btn === type) {
                                        btn.classList.remove('hide');
                                    }
                                })
                            }
                        }
                    }
                })
            }
        } else {
            this.postsGrids.forEach(grid => {
                const postsCount = grid.querySelectorAll('.js-news-card').length;

                if (postsCount >= allPostCount) {
                    if (this.loadMoreBtns.length > 0) {
                        this.loadMoreBtns.forEach(btn => {
                            btn.classList.add('hide');
                        })
                    }
                } else {
                    if (this.loadMoreBtns.length > 0) {
                        this.loadMoreBtns.forEach(btn => {
                            btn.classList.remove('hide');
                        })
                    }
                }
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Archive();
})